import React, { useState } from 'react';
import Thanks from '../../modalThank';
import { FIELDS_CHECK_FORM, FIELDS_FORM } from './fields';

const MESSAGES_ERROR = [
  'Required fields.',
  'An error occurred, try again.',
  'Could not send information, please check your internet connection and try again.',
];

const NAME_FORM = 'CONTACTUSA_EXPO_2022';

const DEFAULT_VALUES_FORM = FIELDS_FORM;

const FormExpo = () => {
  const [fields, setFields] = useState(FIELDS_FORM);
  const [social, setSocial] = useState('');
  const [otherText, setOtherText] = useState('');
  const [indexError, setIndexError] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [isAllEmpty, setIsAllEmpty] = useState(false);
  const [isOpenAlert, setIsOpenAlert] = useState(false);
  const [isErrorMessage, setIsErrorMessage] = useState(false);
  const [isEmptyAboutUs, setIsEmptyAboutUs] = useState(false);

  const requestApi = async (contact) => {
    // TODO: ADD ENV
    const api = 'https://c8btjlx1sg.execute-api.us-east-2.amazonaws.com/prod/contact-form';
    const apiKey = { 'x-api-key': 'uks3cgatl0cz2a5sosfbbrpi7ai4jk03' };

    const request = {
      method: 'POST',
      headers: { ...apiKey },
      body: JSON.stringify(contact),
    };

    setIsLoading(true);

    try {
      const response = await fetch(api, request);
      switch (response.status) {
        case 200:
          setFields(DEFAULT_VALUES_FORM);
          setSocial('');
          setOtherText('');
          setIsOpenAlert(true);
          break;
        case 400:
          setIndexError(0);
          setIsErrorMessage(true);
          break;
        case 405:
          setIndexError(1);
          setIsErrorMessage(true);
          break;
        case 500:
          setIndexError(1);
          setIsErrorMessage(true);
          break;
        default:
          setIndexError(1);
          setIsErrorMessage(true);
          break;
      }
    } catch (e) {
      console.error('Not send info', e);
      setIndexError(2);
      setIsErrorMessage(true);
    } finally {
      setIsLoading(false);
    }
  };

  const setErrorFields = (fieldName) => {
    setFields((prev) => ({
      ...prev,
      [fieldName]: {
        ...prev[fieldName],
        isError: true,
      },
    }));
  };

  const setValueFields = (fieldName, value) => {
    setFields((prev) => ({
      ...prev,
      [fieldName]: {
        ...prev[fieldName],
        isError: false,
        value,
      },
    }));
  };

  const handleChange = (event) => {
    event.preventDefault();
    const {
      target: { name, value },
    } = event;

    setValueFields(name, value);
    setIsAllEmpty(false);
    setIsErrorMessage(false);
    setIsEmptyAboutUs(false);
  };

  const handleChangeChecks = (event) => {
    const {
      target: { name },
    } = event;
    if (social !== name) {
      setSocial(name);
      setOtherText('');
    }
    setIsAllEmpty(false);
    setIsEmptyAboutUs(false);
  };

  const handleChangeOtherText = (event) => {
    event.preventDefault();
    const {
      target: { value },
    } = event;
    setOtherText(value);
  };

  const handleAccept = (event) => {
    event.preventDefault();
    ga('send', 'event', 'Form expo california', 'Click', 'Form finished');
    setIsOpenAlert(false);
  };

  const validFieldsForm = async (event) => {
    ga('send', 'event', 'Form expo california', 'Click', 'Submit');
    event.preventDefault();

    const {
      contactName,
      contactLastName,
      contactEmail,
      contactPhone,
      contactCompany,
      contactCity,
      contactState,
    } = fields;

    const isAllEmpty = Object.values(fields).every((data) => !data.value);
    if (isAllEmpty && !social) {
      setIndexError(0);
      setIsAllEmpty(true);
      setIsErrorMessage(true);
      setIsEmptyAboutUs(true);
      return;
    }

    const checkValidOnlyLetters = /^[A-Za-z\s]+$/g;
    if (!checkValidOnlyLetters.test(contactName.value)) {
      setErrorFields('contactName');
      return;
    }

    const checkValidOnlyLettersLastName = /^[A-Za-z\s]+$/g;
    if (!checkValidOnlyLettersLastName.test(contactLastName.value)) {
      setErrorFields('contactLastName');
      return;
    }

    if (!contactName.value) {
      setErrorFields('contactName');
      return;
    }

    if (!contactLastName.value) {
      setErrorFields('contactLastName');
      return;
    }

    const checkValidEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!checkValidEmail.test(contactEmail.value)) {
      setErrorFields('contactEmail');
      return;
    }

    const checkValidPhone =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    if (!checkValidPhone.test(contactPhone.value)) {
      setErrorFields('contactPhone');
      return;
    }

    if (!contactCompany.value) {
      setErrorFields('contactCompany');
      return;
    }

    if (!contactCity.value) {
      setErrorFields('contactCity');
      return;
    }

    if (!contactState.value) {
      setErrorFields('contactState');
      return;
    }

    if (!social || social === 'other' && !otherText.length) {
      setIsEmptyAboutUs(true);
      return;
    }

    if (isErrorMessage) {
      setIsErrorMessage(false);
    }

    await sendInformationForm(fields);
  };

  const sendInformationForm = async ({
    contactName,
    contactLastName,
    contactEmail,
    contactPhone,
    contactCompany,
    contactCity,
    contactState,
  }) => {
    const aboutUs = social === 'other' && otherText.length ? otherText : social;
    const contact = {
      form: NAME_FORM,
      name: contactName.value,
      lastName: contactLastName.value,
      email: contactEmail.value,
      company: contactCompany.value,
      phone: contactPhone.value,
      city: contactCity.value,
      state: contactState.value,
      aboutUs,
    };
    ga('send', 'event', 'Form expo california', 'Send', 'Request demo');
    setIsLoading(true);
    // setIsOpenAlert(true);
    // TODO: REMOVE SETTIMEOUT AND USE REQUEST API
    await requestApi(contact);
 
  };

  return (
    <>
      <Thanks isOpen={isOpenAlert} onAccept={handleAccept} />
      <div className="form__expo">
        {Object.values(fields).map((element, index) => (
          <div
            key={index}
            className={`container__fields ${
              isAllEmpty && element.isRequired ? 'empty' : ''
            } ${element.isError && element.message ? 'errorMessage' : ''}`}
          >
            <input
              id={element.name}
              name={element.name}
              className={`fields ${element.isError ? 'empty' : ''} `}
              type={element.type}
              placeholder={element.placeholder}
              onChange={handleChange}
              disabled={isLoading}
              value={element.value}
              maxLength={element.maxlength}
            />
            <label htmlFor={element.name} className="error">
              {element.isError && element.message}
            </label>
          </div>
        ))}
        <p className={`subtitle ${isEmptyAboutUs ? 'empty' : ''}`}>
          *How did you hear about us?
        </p>
        {Object.values(FIELDS_CHECK_FORM).map((field) => (
          <label className="form__checkbox" key={field.name}>
            {field.text}
            <input
              className="checkmark"
              type={field.type}
              name={field.name}
              value={field.value}
              disabled={isLoading}
              checked={field.name === social}
              onChange={handleChangeChecks}
            />
            {social === 'other' && field.name === 'other' && (
              <input
                id="other__text"
                type="text"
                name="other__text"
                className={`fields ${
                  !otherText && isEmptyAboutUs ? 'empty' : ''
                } `}
                disabled={isLoading}
                onChange={handleChangeOtherText}
              />
            )}
          </label>
        ))}
        {isEmptyAboutUs && !isAllEmpty && (
          <label className="error text__other">Please enter a option.</label>
        )}
        <p className="required">*Required field.</p>
        <div className={`message ${isErrorMessage ? 'error' : ''}`}>
          <p className="text__message">
            <svg className="icon__message" viewBox="0 0 24 24">
              <path d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" />
            </svg>
            {MESSAGES_ERROR[indexError]}
          </p>
        </div>

        <div className="wrapper__button">
          <button
            id="form__button"
            className="btn btn__send"
            disabled={isLoading}
            onClick={validFieldsForm}
          >
            {!isLoading ? (
              'Request more info'
            ) : (
              <div class="loader__spin">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default FormExpo;
